import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
// import "./style.scss";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { MdClear } from "react-icons/md";
import swal from "sweetalert";
import methodModel from "../../methods/methods";

const Forgotpassword = () => {
  const WebDetails = useSelector((state) => state.logo);
  const history = useNavigate();
  const [ForgotError, setForgotError] = useState(null);
  const user = useSelector((state) => state.user);
  const [Ip, setIp] = useState("Null");
  useEffect(() => {
    if (localStorage.getItem("token")) {
      history("/dashboard");
    }
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        let ip = data.ip;
        localStorage.setItem("IP", ip);
        setIp(ip);
      })
      .catch((error) => {});
  }, []);

  const [form, setForm] = useState({ email: "" });

  const [Submit, setSubmit] = useState(false);
  const hendleSubmit = (e) => {
    e.preventDefault();
    setSubmit(true);
    if (!methodModel.EmailValidator(form?.email)) {
      return;
    }

    setForgotError(null);
    loader(true);

    ApiClient.post(
      "user/admin/forgot/password",
      {
        ...form,
      },
      "",
      true,
      setForgotError,
    ).then((res) => {
      if (res.success) {
        swal({
          text: "Reset password link sent to your email.",
          className: "smallmodal",
          icon: "success",
        });
        history("/login?message=" + res.message);
      }
      loader(false);
    });
  };

  return (
    <>
      <div className="">
        <div
          className="h-screen overflow-auto flex items-start p-5"
          style={{ backgroundImage: "url('/assets/img/auth-bg.webp')" }}
        >
          <div className="max-w-[550px] w-full h-fit bg-white rounded-[40px] sm:p-[4rem] p-[1.5rem] m-auto">
            <div className="w-full bg-white">
              <img
                src="/assets/img/logo.png"
                className="w-[110px] object-contain mx-auto mb-4"
                alt="logo"
              />
              <div className="">
                <form onSubmit={hendleSubmit}>
                  <div className="mb-5">
                    <h3 class="text-[22px] font-[600] text-center leding-[28px]">
                      {" "}
                      Forgot password?
                    </h3>
                    <p class="text-[14px] font-[300] max-w-[328px] text-center mx-auto">
                      No worries! Just enter your email and we’ll send you a
                      reset password link.
                    </p>
                  </div>
                  <div className="space-y-4">
                    <div className="">
                      <p class="text-sm pb-1 font-[400] text-[#737373]">
                        Email
                      </p>
                      <div className="relative mb-6">
                        <input
                          type="email"
                          className="border !outline-none h-11 rounded-[12px] w-full text-sm pl-3 pr-9"
                          placeholder="Email*"
                          value={form.email}
                          required
                          onChange={(e) =>
                            setForm({ ...form, email: e.target.value })
                          }
                        />
                      </div>
                    </div>
                  </div>

                  {Submit &&
                  form?.email != "" &&
                  !methodModel.EmailValidator(form?.email) ? (
                    <div
                      className={`px-4 mt-3 py-2 mb-4 bg-red-400 text-center rounded-large flex items-center justify-between transition-transform duration-500 ${Submit && form?.email != "" && !methodModel.EmailValidator(form?.email) ? "transform translate-y-0" : "transform -translate-y-full"}`}
                    >
                      <span className="text-white text-sm text-center">
                        Enter Valid Email
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                  {ForgotError && (
                    <div
                      className={`px-4 py-2 mb-4 bg-red-400 text-center rounded-large flex items-center justify-between transition-transform duration-500 ${ForgotError ? "transform translate-y-0" : "transform -translate-y-full"}`}
                    >
                      <span className="text-white text-sm text-center">
                        {ForgotError}
                      </span>
                    </div>
                  )}

                  <button
                    type="submit"
                    className="!px-4 w-full text-sm font-[600] text-white h-11 flex items-center justify-center gap-2 !bg-[#115B9D] rounded-[12px] shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed"
                  >
                    Send Recovery Email
                  </button>
                  <p className="text-sm text-[#202020] text-center mt-6">
                    Just Remember?{" "}
                    <Link
                      className="text-[#115B9D] font-medium hover:opacity-80"
                      to="/login"
                    >
                      Login
                    </Link>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer position="top-right" />
    </>
  );
};

export default Forgotpassword;
